import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '@atlassian/jira-relay/src/__generated__/ProductsAppQuery$parameters';

const PRODUCTS_PAGE_SIZE = 50;

export const customerServiceProductsEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-customer-service-products" */ './src/ui'),
	),
	getPreloadProps: ({ tenantContext: { cloudId } }: EntryPointRouteParams) => ({
		queries: {
			ProductsAppQuery: {
				parameters,
				variables: {
					cloudId,
					first: PRODUCTS_PAGE_SIZE,
				},
				options: {
					fetchPolicy: 'network-only' as const,
				},
			},
		},
	}),
});
